import { render, staticRenderFns } from "./DispensaSubestoque.vue?vue&type=template&id=78eaab80"
import script from "./DispensaSubestoque.vue?vue&type=script&lang=js"
export * from "./DispensaSubestoque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports